import {
  cuilGen,
  isValidDate,
  getParameterByName,
  getTrackingCodeLocal,
  obtenerTrackingCode,
  replaceAll,
  toTitleCase,
  isValidCuil,
  obtenerDeviceIdTimestamp,
  obtenerDeviceId,
  normalizeCharacters,
  getEnvironment,
  calcularEdad,
  formatDinero,
  isDev,
  get,
  mergeArrays,
  checkAndAddNoNumber,
  identificarErrorFotoDNI,
  otpIdDevice,
  isEmpty,
  hashSHA256
} from "@/utils/index";
import { getValueByKey } from "../../utils";

describe("Utils full test", () => {
  describe("cuilGen", () => {
    it("should generate a valid CUIL", () => {
      expect(cuilGen("1234567", "HOMBRE")).toMatch("20-01234567-5");
      expect(cuilGen("12345678", "HOMBRE")).toMatch("20-12345678-6");
      expect(cuilGen("23456781", "HOMBRE")).toMatch("20-23456781-1");
      expect(cuilGen("34567812", "HOMBRE")).toMatch("20-34567812-4");
      expect(cuilGen("78123456", "HOMBRE")).toMatch("20-78123456-8");
      expect(cuilGen("81234567", "HOMBRE")).toMatch("20-81234567-3");
      expect(cuilGen("93456712", "HOMBRE")).toMatch("23-93456712-9");

      expect(cuilGen("1234567", "MUJER")).toMatch("23-01234567-4");
      expect(cuilGen("12345678", "MUJER")).toMatch("27-12345678-0");
      expect(cuilGen("23456781", "MUJER")).toMatch("27-23456781-6");
      expect(cuilGen("34567812", "MUJER")).toMatch("27-34567812-9");
      expect(cuilGen("78123456", "MUJER")).toMatch("27-78123456-2");
      expect(cuilGen("81234567", "MUJER")).toMatch("27-81234567-8");

      expect(cuilGen("1234567", "SOCIEDAD")).toMatch("30-01234567-0");
      expect(cuilGen("12345678", "SOCIEDAD")).toMatch("30-12345678-1");
      expect(cuilGen("23456781", "SOCIEDAD")).toMatch("30-23456781-7");
      expect(cuilGen("56781234", "SOCIEDAD")).toMatch("30-56781234-7");
      expect(cuilGen("78123456", "SOCIEDAD")).toMatch("30-78123456-3");
      expect(cuilGen("81234567", "SOCIEDAD")).toMatch("30-81234567-9");
    });

    it("should generate a invalid CUIL", () => {
      expect(cuilGen("1234", "HOMBRE")).toMatch("");
    });

    it("should reject document numbers with letters", () => {
      expect(cuilGen("1234ABCD", "HOMBRE")).toMatch("");
    });

    it("should accept lowercase gender values", () => {
      expect(cuilGen("12345678", "mujer")).toMatch("27-12345678-0");
    });
  });

  describe("replaceAll", () => {
    it("should replace all occurrences of a substring in a string", () => {
      const str = "Hello, World!";
      const search = "o";
      const replacement = "x";
      const expectedMock = "Hellx, Wxrld!";
      const result = replaceAll(str, search, replacement);
      expect(result).toEqual(expectedMock);
    });
    it("should replace all occurrences of a substring in an empty string", () => {
      const str = "";
      const search = "a";
      const replacement = "x";
      const expectedMock = "";
      const result = replaceAll(str, search, replacement);
      expect(result).toEqual(expectedMock);
    });
    it("should replace all occurrences of a substring in a string with no matches", () => {
      const str = "Hello, World!";
      const search = "x";
      const replacement = "y";
      const expectedMock = "Hello, World!";
      const result = replaceAll(str, search, replacement);
      expect(result).toEqual(expectedMock);
    });
    it("should replace all occurrences of a substring in a string with multiple matches", () => {
      const str = "Hello, World!";
      const search = "l";
      const replacement = "x";
      const expectedMock = "Hexxo, Worxd!";
      const result = replaceAll(str, search, replacement);
      expect(result).toEqual(expectedMock);
    });
  });

  describe("toTitleCase", () => {
    it("should convert a string to title case", () => {
      const str = "hello, world!";
      const expectedMock = "Hello, World!";
      const result = toTitleCase(str);
      expect(result).toEqual(expectedMock);
    });
    it("should convert an empty string to an empty string", () => {
      const str = "";
      const expectedMock = "";
      const result = toTitleCase(str);
      expect(result).toEqual(expectedMock);
    });
    it("should convert a string with multiple words to title case", () => {
      const str = "this is a test";
      const expectedMock = "This Is A Test";
      const result = toTitleCase(str);
      expect(result).toEqual(expectedMock);
    });
  });

  describe("isDev", () => {
    it("should return environment constant", () => {
      expect(isDev()).toBe(true);
    });
  });

  describe("isValidDate", () => {
    it("should return true for a valid date string", () => {
      expect(isValidDate("01/01/2024")).toBe(true);
    });
    it("should return false for an invalid date string", () => {
      expect(isValidDate("30/02/2024")).toBe(false);
    });
    it("should return false for an empty date string", () => {
      expect(isValidDate("")).toBe(false);
    });
    it("should return false for stone age", () => {
      expect(isValidDate("01/01/4000")).toBe(false);
    });

    it("should return false if age is lower than minimum", () => {
      expect(isValidDate("01/01/2020", "18", "65")).toBe(false);
    });
    it("should return false if age is upper than maximum", () => {
      expect(isValidDate("01/01/1905", "18", "65")).toBe(false);
    });

    it("should return true if age is within min and max range", () => {
      expect(isValidDate("01/01/1990", "18", "65")).toBe(true);
    });

    it("should accept leap day on leap years", () => {
      expect(isValidDate("29/02/2024")).toBe(true);
    });
  });

  describe("getParameterByName", () => {
    it("should return the value of the specified parameter from the URL", () => {
      const url = "https://example.com/?name=John&age=30";
      const name = "name";
      const expectedMock = "John";
      const result = getParameterByName(name, url);
      expect(result).toEqual(expectedMock);
    });
    it("should return null value when not exists parameters", () => {
      const url = "https://example.com/";
      const name = "name";
      const result = getParameterByName(name, url);
      expect(result).toBeNull();
    });
    it("should return empty value of the specified parameter from the URL with name", () => {
      const url = "https://example.com/?name=John&age=30&address=";
      const name = "address";
      const expectedMock = "";
      const result = getParameterByName(name, url);
      expect(result).toEqual(expectedMock);
    });
    it("should return empty value of the specified parameter from the URL empty", () => {
      const url = "";
      const name = "address";
      const result = getParameterByName(name, url);
      expect(result).toBeNull();
    });
  });
  describe("Devoluciones por defecto cuando no tiene el parametro", () => {
    it("tracking code for the specified name", () => {
      expect(getTrackingCodeLocal("John")).toBe(null);
    });
    it("tracking code empty", () => {
      expect(obtenerTrackingCode()).toMatch("");
    });
  });
  describe("getTrackingCodeLocal", () => {
    beforeEach(() => {
      delete window.location;
      window.location = {
        href:
          "https://example.com/?track=UnTrack&origen=UnOrigen&cid=Un:tracking:viejo:de:Cid"
      };
    });
    it("should return the tracking code for the specified name", () => {
      expect(getTrackingCodeLocal("track")).toBe("UnTrack");
    });
    it("should return the tracking code for the specified name out params", () => {
      expect(obtenerTrackingCode()).toBe("-Un-tracking-viejo-de");
    });
    it("should return other tracking code for the out params", () => {
      delete window.location;
      window.location = {
        href: "https://example.com/?onsite=esto-es-un-valor-nuevo"
      };
      expect(obtenerTrackingCode()).toBe("-esto-es-un-valor");
    });
    afterAll(() => {
      window.location.href = "";
    });
  });

  describe("Es cuil valido", () => {
    it("should return true when cuil is valid", () => {
      expect(isValidCuil("20012345675")).toBe(true);
    });

    it("should return true when verifier resolves to 0", () => {
      expect(isValidCuil("20000000060")).toBe(true);
    });

    it("should return false when cuil is invalid", () => {
      expect(isValidCuil("20012345670")).toBe(false);
    });
    it("should return false when cuil hasn't value", () => {
      expect(isValidCuil()).toBe(false);
    });
    it("should return false when cuil is not a number", () => {
      expect(isValidCuil("cuil")).toBe(false);
    });
    it("should return false when cuil size not equals to 11 characters", () => {
      expect(isValidCuil("30")).toBe(false);
    });
  });

  describe("obtenerDeviceIdTimestamp", () => {
    it("should return timeStamp in local storage if exists", () => {
      localStorage.setItem("timeStamp", "2024-04-01T00:00:00.000Z");
      expect(obtenerDeviceIdTimestamp()).toBe("2024-04-01T00:00:00.000Z");
    });
    it("should return new timestamp when its empty", () => {
      localStorage.setItem("timeStamp", "");
      expect(obtenerDeviceIdTimestamp()).not.toBeNull();
    });
  });

  describe("obtenerDeviceId", () => {
    it("debe devolver el ID del dispositivo guardado en localStorage", () => {
      localStorage.setItem("uId", "stored-device-id");
      expect(obtenerDeviceId()).toBe("stored-device-id");
    });

    it("debe obtener el ID del dispositivo", () => {
      localStorage.removeItem("uId");
      expect(obtenerDeviceId()).not.toBeUndefined();
    });
  });

  describe("getEnvironment", () => {
    it("Debe devolver el entorno Desarrollo", () => {
      expect(getEnvironment().description).toBe("Desarrollo");
    });
  });

  describe("getEnvironment www.bbva.com.ar", () => {
    beforeEach(() => {
      global.window = Object.create(window);
      Object.defineProperty(window, "location", {
        value: {
          hostname: "www.bbva.com.ar"
        },
        writable: true
      });
    });

    it("Debe devolver el entorno Produccion", () => {
      expect(getEnvironment().description).toBe("Produccion");
    });
  });

  describe("getEnvironment app-work.bbva.com.ar", () => {
    beforeEach(() => {
      global.window = Object.create(window);
      Object.defineProperty(window, "location", {
        value: {
          hostname: "app-work.bbva.com.ar"
        },
        writable: true
      });
    });

    it("Debe devolver el entorno Test", () => {
      expect(getEnvironment().description).toBe("Test");
    });
  });

  describe("calcularEdad", () => {
    it("debe calcular la edad desde una fecha de nacimiento", () => {
      let fechaDeHoyMenos21Anios = new Date();
      fechaDeHoyMenos21Anios.setFullYear(
        fechaDeHoyMenos21Anios.getFullYear() - 21
      );

      let fechaNacimiento =
        fechaDeHoyMenos21Anios.getFullYear() +
        "-" +
        (fechaDeHoyMenos21Anios.getMonth() + 1) +
        "-" +
        fechaDeHoyMenos21Anios.getDate();

      expect(calcularEdad(fechaNacimiento)).toBe("21");
    });

    it("debe devolver vacio si no se pasa una fecha", () => {
      expect(calcularEdad()).toBe("");
    });

    it("debe devolver vacio si no es una fecha o es NaN", () => {
      expect(calcularEdad("undefined")).toBe("");
    });

    it("debe calcular la edad desde una fecha", () => {
      const hoy = new Date();
      const hace24 = new Date(
        hoy.getFullYear() - 24,
        hoy.getMonth(),
        hoy.getDate()
      );
      const fechaNacimiento = `${hace24.getFullYear()}-${hace24.getMonth() +
        1}-${hace24.getDate()}`;
      expect(calcularEdad(fechaNacimiento)).toBe("24");
    });

    it("debe restar un año cuando todavía no cumplió años", () => {
      const hoy = new Date();
      const fechaNoCumplida = new Date(
        hoy.getFullYear() - 24,
        hoy.getMonth() + 1,
        hoy.getDate()
      );
      const fechaNacimiento = `${fechaNoCumplida.getFullYear()}-${fechaNoCumplida.getMonth() +
        1}-${fechaNoCumplida.getDate()}`;

      expect(calcularEdad(fechaNacimiento)).toBe("23");
    });
  });

  describe("formatDinero", () => {
    it("function formatDinero", () => {
      expect(formatDinero()).not.toBeUndefined();
    });
  });

  describe("get", () => {
    it("get function", () => {
      expect(get({}, "/", false)).toBe(false);
    });

    it("should return default value when lodashGet returns null", () => {
      expect(get({ a: null }, "a", "default")).toBe("default");
    });
  });

  describe("normalizeCharacters", () => {
    it("should return normalized string", () => {
      expect(normalizeCharacters("Texto normalizado")).toBe(
        "Texto normalizado"
      );
    });

    it("should return normalized object", () => {
      expect(normalizeCharacters("")).toBe("");
    });
  });

  describe("mergeArrays", () => {
    it("should return combined object", () => {
      expect(mergeArrays({ key1: "value1" }, { key2: "value2" })).toEqual({
        key1: "value1",
        key2: "value2"
      });
    });
  });

  describe("getValueByKey", () => {
    it("should return defaultValue", () => {
      expect(getValueByKey("key2", "", "key2", {}, "defaultValue")).toBe(
        "defaultValue"
      );
    });

    it("should return key value", () => {
      expect(
        getValueByKey(
          "key2",
          "value2",
          "key2",
          [
            {
              key1: "value1",
              key2: "value2",
              key3: "value3"
            }
          ],
          "defaultValue"
        )
      ).toBe("value2");
    });

    it("should return defaultValue when is object array", () => {
      expect(
        getValueByKey(
          "key2",
          "",
          "key2",
          [
            {
              key1: "value1",
              key2: "value2",
              key3: "value3"
            }
          ],
          "defaultValue"
        )
      ).toBe("defaultValue");
    });
  });

  describe("checkAndAddNoNumber", () => {
    it("should return address with no number", () => {
      expect(checkAndAddNoNumber("Av. Buenos Aires")).toBe(
        "AV. BUENOS AIRES S/N"
      );
    });

    it("should return address with S/N when address have SIN NUMERO", () => {
      expect(checkAndAddNoNumber("Av. Buenos Aires SIN NUMERO")).toBe(
        "AV. BUENOS AIRES S/N"
      );
    });

    it("should return address with S/N when address have SN", () => {
      expect(checkAndAddNoNumber("Av. Buenos Aires SN")).toBe(
        "AV. BUENOS AIRES S/N"
      );
    });

    it("should return address without S/N", () => {
      expect(checkAndAddNoNumber("Av. Buenos Aires 123")).toBe(
        "AV. BUENOS AIRES 123"
      );
    });

    it("should keep address ending with S/N", () => {
      expect(checkAndAddNoNumber("Av. Buenos Aires S/N")).toBe(
        "AV. BUENOS AIRES S/N"
      );
    });
  });

  describe("identificarErrorFotoDNI", () => {
    it("should return error-tokenExpired", () => {
      expect(identificarErrorFotoDNI("Access token expired")).toBe(
        "error-tokenExpired"
      );
    });

    it("should return error-dni", () => {
      expect(identificarErrorFotoDNI("Error DNI")).toBe("error-dni");
    });
  });

  describe("otpIdDevice", () => {
    it("should return deviceID from MediaDeviceInfo", () => {
      Object.defineProperty(window, "MediaDeviceInfo", {
        value: {
          deviceId: "123456"
        },
        writable: true
      });
      expect(otpIdDevice()).toBe("123456");
    });

    it("should return uid from navigator", () => {
      Object.defineProperty(window, "navigator", {
        value: {
          mimeTypes: {
            length: 1
          },
          userAgent: "Chrome",
          plugins: {
            length: 1
          }
        }
      });

      Object.defineProperty(window, "MediaDeviceInfo", {
        value: {
          deviceId: undefined
        },
        writable: true
      });
      expect(otpIdDevice()).toBe("1124");
    });

    it("should include pixelDepth when available", () => {
      Object.defineProperty(window, "navigator", {
        value: {
          mimeTypes: {
            length: 1
          },
          userAgent: "Chrome",
          plugins: {
            length: 1
          }
        }
      });

      Object.defineProperty(window, "screen", {
        value: {
          height: 2,
          width: 4,
          pixelDepth: 8
        },
        writable: true,
        configurable: true
      });

      Object.defineProperty(window, "MediaDeviceInfo", {
        value: {
          deviceId: undefined
        },
        writable: true
      });

      expect(otpIdDevice()).toBe("11248");
    });

    it("should omit pixelDepth when it is falsy", () => {
      Object.defineProperty(window, "navigator", {
        value: {
          mimeTypes: {
            length: 1
          },
          userAgent: "Chrome",
          plugins: {
            length: 1
          }
        }
      });

      Object.defineProperty(window, "screen", {
        value: {
          height: 2,
          width: 4,
          pixelDepth: 0
        },
        writable: true,
        configurable: true
      });

      Object.defineProperty(window, "MediaDeviceInfo", {
        value: {
          deviceId: undefined
        },
        writable: true
      });

      expect(otpIdDevice()).toBe("1124");
    });
  });
  describe("isEmpty", () => {
    it("should return true for undefined value", () => {
      expect(isEmpty(undefined)).toBe(true);
    });

    it("should return true for null value", () => {
      expect(isEmpty(null)).toBe(true);
    });

    it("should return true for empty string", () => {
      expect(isEmpty("")).toBe(true);
    });

    it("should return true for whitespace string", () => {
      expect(isEmpty("   ")).toBe(true);
    });

    it("should return false for non-empty string", () => {
      expect(isEmpty("Hello")).toBe(false);
    });
  });

  describe("hashSHA256", () => {
    const originalCrypto = window.crypto;
    const originalTextEncoder = global.TextEncoder;

    afterEach(() => {
      Object.defineProperty(window, "crypto", {
        value: originalCrypto,
        writable: true,
        configurable: true
      });
      global.TextEncoder = originalTextEncoder;
    });

    it("should return empty string when value is missing", async () => {
      await expect(hashSHA256("")).resolves.toBe("");
    });

    it("should return empty string when subtle crypto is not available", async () => {
      Object.defineProperty(window, "crypto", {
        value: {},
        writable: true,
        configurable: true
      });

      await expect(hashSHA256("value")).resolves.toBe("");
    });

    it("should return empty string when window is not available", async () => {
      const originalWindow = global.window;

      delete global.window;

      await expect(hashSHA256("value")).resolves.toBe("");

      global.window = originalWindow;
    });

    it("should hash a value with subtle crypto", async () => {
      const digestMock = jest
        .fn()
        .mockResolvedValueOnce(Uint8Array.from([0, 255, 16]).buffer);

      global.TextEncoder = class {
        encode(value) {
          return value;
        }
      };

      Object.defineProperty(window, "crypto", {
        value: {
          subtle: {
            digest: digestMock
          }
        },
        writable: true,
        configurable: true
      });

      await expect(hashSHA256("abc")).resolves.toBe("00ff10");
      expect(digestMock).toHaveBeenCalledWith("SHA-256", "abc");
    });

    it("should return empty string when digest throws", async () => {
      Object.defineProperty(window, "crypto", {
        value: {
          subtle: {
            digest: jest.fn().mockRejectedValueOnce(new Error("crypto error"))
          }
        },
        writable: true,
        configurable: true
      });

      await expect(hashSHA256("abc")).resolves.toBe("");
    });
  });
});
